import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaEnvelope, FaQuestion } from 'react-icons/fa';
import ThemeContext from '../../contexts/ThemeContext';
import { endpoint } from '../../utils/endpoint';
import { igLink } from '../../utils/links';
import './BottomCircleMenu.css';

const FAB_HINTS = {
    he: { wsp: 'וואטסאפ', help: 'עזרה' },
    ar: { wsp: 'واتساب', help: 'مساعدة' },
    en: { wsp: 'WhatsApp', help: 'Help' },
};

const BottomCircleMenu = ({ phone, lng, font = 'he', onOpenHelp }) => {
    const { theme } = useContext(ThemeContext);
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const navRef = useRef(null);
    const assetsUrl = `${endpoint}assets`;

    const segment = location.pathname.split('/').filter(Boolean)[0];
    const hintKey = segment === 'en' ? 'en' : font;
    const contactEntry = lng?.menu?.[4] || ['Contact', 'contact'];
    const contactLabel = contactEntry[0];
    const contactHash = `#${contactEntry[1]}`;
    const hints = FAB_HINTS[hintKey] || FAB_HINTS.he;
    const helpLabel = lng?.helpRouter?.fabLabel || hints.help;

    useEffect(() => {
        if (!open) return;
        const close = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', close);
        return () => document.removeEventListener('mousedown', close);
    }, [open]);

    const scrollToContact = (e) => {
        e.preventDefault();
        setOpen(false);
        const el = document.querySelector(contactHash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <>
            {open && (
                <button
                    type="button"
                    className="menux-backdrop"
                    aria-label="Close menu"
                    onClick={() => setOpen(false)}
                />
            )}
            <nav
                ref={navRef}
                className={`menux menux--${theme.mode} ${open ? 'is-open' : ''}`}
            >
                <input
                    type="checkbox"
                    className="menu-open"
                    id="menu-open"
                    checked={open}
                    onChange={(e) => setOpen(e.target.checked)}
                />
                <label className="menu-open-button" htmlFor="menu-open" aria-label="Quick actions">
                    <span className="lines line-1" />
                    <span className="lines line-2" />
                    <span className="lines line-3" />
                </label>

                <button
                    type="button"
                    className="menu-item menu-item--help"
                    data-tooltip={helpLabel}
                    aria-label={helpLabel}
                    onClick={() => {
                        setOpen(false);
                        if (onOpenHelp) onOpenHelp();
                    }}
                >
                    <FaQuestion size={18} className="menu-item-icon" />
                </button>

                <button
                    type="button"
                    className="menu-item menu-item--wsp"
                    data-tooltip={hints.wsp}
                    aria-label={hints.wsp}
                    onClick={() => {
                        setOpen(false);
                        window.open(
                            `https://api.whatsapp.com/send?phone=${phone}`,
                            '_blank'
                        );
                    }}
                >
                    <img
                        className="flag-icon"
                        src={`${assetsUrl}/wsp.svg`}
                        alt=""
                    />
                </button>

                <a
                    href={contactHash}
                    className="menu-item menu-item--contact"
                    data-tooltip={contactLabel}
                    aria-label={contactLabel}
                    onClick={scrollToContact}
                >
                    <FaEnvelope size={20} className="menu-item-icon" />
                </a>

                <a
                    href={igLink}
                    target="_blank"
                    rel="noreferrer"
                    className="menu-item menu-item--ig"
                    data-tooltip="Instagram"
                    aria-label="Instagram"
                    onClick={() => setOpen(false)}
                >
                    <img
                        className="flag-icon"
                        src={`${assetsUrl}/ig.svg`}
                        alt=""
                    />
                </a>
            </nav>
        </>
    );
};

export default BottomCircleMenu;
